const appSettings = {
    apiUrl: process.env.NODE_ENV === "production"
        ? "https://dating-api.juicyelf.com"
        : "http://localhost:3049"
};

export default appSettings;
